/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateCompetenceRequestViewModel } from "../types/UpdateCompetenceRequestViewModel.ts";

export const updateCompetenceRequestViewModelSchema = z.object({
  name: z.string().describe("Nome da competência.").nullish(),
  description: z
    .string()
    .describe("Descrição da competência. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe("Idioma (cultura) da tradução a ser atualizada.")
    .nullish(),
}) as unknown as ToZod<UpdateCompetenceRequestViewModel>;
